import styled from 'styled-components';
import { StyledContainer as Container } from "./base.styles";
export var StyledContainer = styled(Container).withConfig({
  componentId: "sc-12gasgl-0"
})([""]);
export var StyledMessageContainer = styled.div.withConfig({
  componentId: "sc-12gasgl-1"
})(["display:inline-block;flex-grow:1;"]);
export var StyledMessage = styled.p.withConfig({
  componentId: "sc-12gasgl-2"
})(["display:inline;margin:0;"]);
export var StyledCtaLink = styled.a.withConfig({
  componentId: "sc-12gasgl-3"
})(["text-decoration:underline;font-weight:600;white-space:nowrap;"]);